import React from "react";
import { ENUM_FORM_DISPLAY, ENUM_FORM_LAYOUT_CONTAINER } from "./pageList";
import { useFormRender } from "../hooks/useFormRender";
import {
  Button,
  Text,
  TextInput,
  Select,
  Textarea,
  Checkbox,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { IconSettings } from "@tabler/icons";
import DateOffPicker from "./dateOffPicker";
import { useServerApi } from "../hooks/userServerApi";
import { DATA_POLICY_DELIVER_METHODS } from "../data/options";
import { showNotification } from "@mantine/notifications";
import { IconCheck } from "@tabler/icons";
import DummyWidget from "./dummyWidget";
import ReactJson from "react-json-view";

const QuoConfirmButton = ({
  mainForm,
  newStatus = "CONFIRM",
  title = "Confirm Quotation",
  confirmText = "Are you sure client confirm the quotation and ready for create debit note?",
  color = "green",
}) => {
  const [api] = useServerApi();
  const formSchema = {
    title,
    description: "Please follow the step",

    display: {
      mode: ENUM_FORM_DISPLAY.MODAL,
      size: "xl", //xs, sm, xl  ....100%
    },
    showSaveBar: true,
    closeAfterSave: true,

    initialValues: {
      confirmed: false,
    },
    validate: {
      confirmed: (v) => (!v ? "" : null),
    },

    layout: {
      containers: [
        {
          key: "section-confirm",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            // title: "Confirm Policy",
            description: "Please enter the form to complete the confirmation",
            withBorder: false,
            mt: 0,
            ml: 20,
          },
        },
      ],

      fields: [
        {
          name: "cancel",
          component: DummyWidget,
          parent: "section-confirm",
          props: {
            dummy: <Text>{confirmText}</Text>,
          },
        },
      ],
    },
  };

  const onSubmit = async ({ values, formMode }) => {
    // console.log("onSubmit", values._id);
    const update = { status: newStatus };
    mainForm.setValues(update);
    await mainForm.saveValues(update);
    formAction.close();

    showNotification({
      title: `Quote Request ${values.code} has been confirmed`,
      icon: <IconCheck size={18} />,
      message: "Data Saved",
    });
  };

  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    formSchema,
    null,
    onSubmit
  );

  const handleActionClick = () => {
    const id = mainForm?.values._id;
    // console.log('%corderPrintCoverSheetActionButton.js line:86 object', 'color: #007acc;', id);
    if (!id) return;
    formAction.open({ mode: "edit", id, data: mainForm.values });
  };

  return (
    <>
      <Button fullWidth onClick={handleActionClick} color={color}>
        {title}
      </Button>

      {renderForm()}
    </>
  );
};

export default QuoConfirmButton;
